'use client';

import { useEffect, useState } from 'react';
import type { CharacterKey, CharacterLite } from '@/lib/voicePreset/types';
import { loadAllCharacters } from '@/lib/voicePreset/loadAllCharacters';

function keyToString(k: CharacterKey): string {
  return k.kind === 'db' ? `db:${k.id}` : `ss:${k.slug}:${k.kebab}`;
}
function stringToKey(s: string): CharacterKey | null {
  if (s.startsWith('db:')) return { kind: 'db', id: s.slice(3) };
  const m = s.match(/^ss:([^:]+):(.+)$/);
  return m ? { kind: 'ss', slug: m[1], kebab: m[2] } : null;
}

export interface CharacterPickerProps {
  value: CharacterKey | null;
  onChange: (key: CharacterKey | null) => void;
  placeholder?: string;
}

export default function CharacterPicker({ value, onChange, placeholder = '(未選択)' }: CharacterPickerProps) {
  const [chars, setChars] = useState<CharacterLite[]>([]);
  useEffect(() => { loadAllCharacters().then(setChars).catch(console.error); }, []);

  return (
    <select
      className="rounded border border-gray-300 px-2 py-1 text-sm"
      value={value ? keyToString(value) : ''}
      onChange={(e) => onChange(e.target.value ? stringToKey(e.target.value) : null)}
    >
      <option value="">{placeholder}</option>
      {chars.map((c) => (
        <option key={keyToString(c.key)} value={keyToString(c.key)}>
          {c.name}{c.voicePresetId ? '' : ' (声未設定)'}
        </option>
      ))}
    </select>
  );
}
